<template>
  <div class="filter-make-grid">
    <div class="grid grid-cols-3 gap-2">
      <div 
        v-for="option in filteredOptions" 
        :key="option.value"
        class="cursor-pointer"
        @click="toggleOption(option.value)"
      >
        <div 
          class="aspect-square rounded-lg border flex flex-col items-center justify-center p-2"
          :class="isOptionSelected(option.value) ? 'border-primary bg-primary/5' : 'border-border bg-background hover:bg-accent/50'"
        >
          <div v-if="option.icon" class="w-10 h-10 mb-1">
            <img :src="option.icon" :alt="option.displayValue" class="w-full h-full object-contain" />
          </div>
          <div v-else class="w-10 h-10 mb-1 bg-secondary/50 rounded-full flex items-center justify-center">
            <span class="text-xs font-medium">{{ option.displayValue.charAt(0) }}</span>
          </div>
          <div class="text-center text-xs truncate">{{ option.displayValue }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useFilters } from '~/layers/base/composables/useFilters'
const props = defineProps({
  filter: {
    type: Object,
    required: true
  },
  activeValue: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['update:value', 'clear'])

const { getFilterOptionCount } = useFilters()

// Get count of vehicles for a filter option
const getOptionCount = (optionValue: string): number => {
  if (!props.filter) return 0
  return getFilterOptionCount(props.filter.name, optionValue)
}

// Filter options to only show those with count > 0
const filteredOptions = computed(() => {
  if (!props.filter || !props.filter.data || !Array.isArray(props.filter.data)) {
    return []
  }
  
  return props.filter.data.filter((option: any) => {
    return getOptionCount(option.value) > 0
  })
})

// Check if an option is selected
const isOptionSelected = (value: string) => {
  return Array.isArray(props.activeValue) && props.activeValue.includes(value)
}

// Toggle an option selection
const toggleOption = (value: string) => {
  if (!Array.isArray(props.activeValue)) {
    emit('update:value', [value])
    return
  }
  
  if (isOptionSelected(value)) {
    const newValue = props.activeValue.filter(v => v !== value)
    emit('update:value', newValue.length ? newValue : undefined)
  } else {
    emit('update:value', [...props.activeValue, value])
  }
}
</script>
